module.exports = __webpack_public_path__ + "static/BIG-pastshow-1004x1004-826566542282398d97fd754b3b78cbe4.jpg";